import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const ImageSlider = () => {
  const slides = [
    // Responsible Mining Strategy - 4 images
    { id: 2, image: '/mining-1.jpg', alt: 'Mining site with tent structures and workers' },
    { id: 3, image: '/mining-2.jpg', alt: 'Mining workers with colorful umbrella' },
    { id: 4, image: '/mining-3.jpg', alt: 'Excavator working in mining site with forest' },
    { id: 5, image: '/mining-4.jpg', alt: 'Wooden mining structure and equipment' },
    
    // TotalEnergies Community Development - 3 images
    { id: 6, image: '/totalenergies-1.png', alt: 'NDE training presentation with banners' },
    { id: 7, image: '/totalenergies-2.png', alt: 'The Emporium Training Center session' },
    { id: 8, image: '/totalenergies-3.jpg', alt: 'Workshop participant writing notes' },
    
    // Minamata Convention - 3 images
    { id: 9, image: '/minamata-1.png', alt: 'Community meeting in open-air pavilion' },
    { id: 10, image: '/minamata-2.png', alt: 'Aerial view showing mining deforestation impact' },
    { id: 11, image: '/minamata-3.png', alt: 'Mining area aerial view with blue pools' },
    
    // LACH Project - 3 images
    { id: 12, image: '/lach-1.png', alt: 'Welcome sign to Matawai Area' },
    { id: 13, image: '/lach-2.png', alt: 'Rural wooden house with massive trees' },
    { id: 14, image: '/lach-3.png', alt: 'Forest road through project area' },
    
    // NGO Organizational Development - 2 images
    { id: 15, image: '/ngo-1.png', alt: 'Green Partnership Program training group photo' },
    { id: 16, image: '/ngo-2.png', alt: 'Akanimbi Poku environmental conservation sign' }
  ];

  return (
    <div className="w-full" data-testid="image-slider">
      <Swiper
        modules={[Navigation, Pagination, Autoplay]}
        spaceBetween={30}
        slidesPerView={1}
        navigation
        pagination={{ clickable: true }}
        autoplay={{ delay: 5000, disableOnInteraction: false }}
        loop={true}
        className="w-full h-[500px]"
      >
        {slides.map((slide) => (
          <SwiperSlide key={slide.id}>
            <div className="relative w-full h-full">
              <img 
                src={slide.image} 
                alt={slide.alt}
                className="w-full h-full object-cover"
              />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
      
      <style jsx>{`
        :global(.swiper-button-next),
        :global(.swiper-button-prev) {
          color: #aaae10;
          background: white;
          width: 50px;
          height: 50px;
          border-radius: 50%;
          box-shadow: 0 2px 8px rgba(0,0,0,0.2);
        }
        
        :global(.swiper-button-next:after),
        :global(.swiper-button-prev:after) {
          font-size: 20px;
          font-weight: bold;
        }
        
        :global(.swiper-pagination-bullet) {
          background: white;
          opacity: 0.7;
        }
        
        :global(.swiper-pagination-bullet-active) {
          background: #aaae10;
          opacity: 1;
        }
      `}</style>
    </div>
  );
};

export default ImageSlider;
